import { render, staticRenderFns } from "./PopupLogin.vue?vue&type=template&id=076a7a3e&scoped=true"
import script from "./PopupLogin.vue?vue&type=script&lang=js"
export * from "./PopupLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a7a3e",
  null
  
)

export default component.exports